import { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { LinkIcon, PlusIcon } from '..';
import { UserContext } from '../../../Provider';
import { AppearComponentHandle } from '../../../components/AppearComponentHandle';
import AGButton from '../../../components/Button';
import { ContactProps } from './contact.props';
import { Div } from './contactModal.styled';
import AGButtonV2 from '../../../components/ButtonV2';
import { InquiriesIcon } from '../../../components/Header';
import {useState, useEffect} from 'react';
import {API_CONSTANT} from '../../../utils/constant';

const apiDomain = process.env.REACT_APP_API_DOMAIN;

const RegionContactsModal = ({ setShow, bodyContent, data, dataService, dataServd, setShowSendMessage, onSelectRegion }: ContactProps) => {
    const { id } = useParams();
    const user = useContext(UserContext);

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useEffect(() => {
         const handleResize = () => {
             setScreenWidth(window.innerWidth);
         };
     
         window.addEventListener("resize", handleResize);
     
         return () => {
             window.removeEventListener("resize", handleResize);
         };
    }, []);

    if (dataService === undefined) {
        return null;
    }

    const groupedContacts = dataServd?.reduce((result, contact) => {
        const nameKey = `${contact.firstName ?? ""}-${contact.lastName ?? ""}`;
        const key = contact.id ?? contact.individualId ?? nameKey;
        if (!result[key]) {
            result[key] = {
                ...contact,
                regions: new Set<string>()
            };
        }
        if (contact.netRegionName) {
            result[key].regions.add(contact.netRegionName);
        }
        return result;
    }, {} as Record<string, (typeof dataServd)[number] & { regions: Set<string> }>);

    const sortedContacts = groupedContacts
        ? Object.values(groupedContacts).sort((a, b) => {
            const firstNameCompare = (a.firstName ?? "").localeCompare(b.firstName ?? "");
            if (firstNameCompare !== 0) return firstNameCompare;
            return (a.lastName ?? "").localeCompare(b.lastName ?? "");
        })
        : [];

    return (
        <>
            {sortedContacts.length ?
                <Div className="contact-contents" >
                    {
                        sortedContacts.map(x => (
                            <div className="firm-idv-contact" key={x.id ?? `${x.firstName}-${x.lastName}` }>
                                <div className='contact-img'>
                                    {x.avatar && typeof x.avatar === 'string' && x.avatar.trim() !== '' ? (
                                        <img src={x.avatar} alt="avatar" className="ava" />
                                    ) : data?.logoPart ? (
                                        <img
                                            src={data.defaultLogo ? data.logoPart : `${apiDomain}${API_CONSTANT.DEFAULT_PROFILE.IMG}${encodeURIComponent(data.logoPart)}`}
                                            alt=""
                                            className="ava"
                                        />
                                    ) : (
                                        <div className='ava' />
                                    )}
                                </div>
                                <div className='contact-name-service flex flex-col'>
                                    <div className="flex items-center gap-2">
                                        <p className="text-[12px] font-semibold text-[#4B4B4B]">
                                            {Array.from(x.regions).sort().join(", ")}
                                        </p>
                                        {x.individualEmailAddr && (
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    onSelectRegion?.(x.fkNetRegionId);
                                                    setShowSendMessage?.();
                                                }}
                                                className="inline-flex items-center text-[#0971A2]"
                                                aria-label={`Email ${x.firstName} ${x.lastName}`}
                                            >
                                                <svg
                                                    width="12"
                                                    height="12"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
                                                </svg>
                                            </button>
                                        )}
                                    </div>
                                    <p className="mt-[2px]">
                                        <span>{x.firstName + ' ' + x.lastName}</span>
                                    </p>
                                </div>
                            </div>
                        ))
                    }
                </Div>
                : user?.firmAddress.firmId === data?.fkFirmId
                    ?
                    <Div className='btn-add-new'>
                        <AGButton
                            type={'Link'}
                            icon={<PlusIcon />}
                            onClick={() => {
                                setShow()
                            }}>
                            {bodyContent}
                        </AGButton>
                    </Div> : <></>
            }
        </>
    )
}

export default RegionContactsModal;